import { render, staticRenderFns } from "./teamInfo.vue?vue&type=template&id=64d4cace&scoped=true"
import script from "./teamInfo.vue?vue&type=script&lang=js"
export * from "./teamInfo.vue?vue&type=script&lang=js"
import style0 from "./teamInfo.vue?vue&type=style&index=0&id=64d4cace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4cace",
  null
  
)

export default component.exports